import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { LocalStorageService } from 'ngx-webstorage';
import { MotesUrlParams } from '../models/motes-url-params';
import { Mote } from '../models/mote';
import { MoteEvent } from '../models/mote-event';
import { MoteEventType } from '../models/mote-event-type';
import { Observable, Subject } from 'rxjs';
import { ProjectService } from './project.service';
import { MoteEventService } from './mote-event.service';
import { MotesPaths } from '../models';

@Injectable({ providedIn: 'root' })

export class IntroFlowService {

    public introFlowRunning: boolean = false;
    public introFlowShowing: boolean = false;
    public tour: Mote = null;
    private urlParams: MotesUrlParams = null;
    private moteEvent: MoteEvent = null;
    public urlChangeSubject = new Subject<string>();
    public currentStory: Mote = null;

    constructor(private storage: LocalStorageService,
        private location: Location,
        private projectService: ProjectService,
        private eventService: MoteEventService) {
        // Watch url change for page key fragments
        this.location.onUrlChange((url) => {
            this.urlChangeSubject.next(url);
        });
    }

    public async init(ev: MoteEvent, tourStarted: Mote, urlParams: MotesUrlParams, setActiveTour: boolean, currentStory: Mote) {
        // Set tour just started or active tour for intro flow
        this.tour = tourStarted;
        this.currentStory = currentStory;
        if(!this.tour && setActiveTour) this.tour = await this.projectService.getActiveTour();
        // Only show intro flow with active tour or tour start (a poolKey in URL (Claim or Share page) will set 'default-tour')
        if(!this.tour || (this.tour.key == MotesPaths.DEFAULT_TOUR_KEY) || !this.tour.doesExist) return;
        this.moteEvent = ev;
        this.urlParams = urlParams;
        this.introFlowRunning = true;
    }

    public close() {
        this.introFlowRunning = false;
        this.moteEvent = null;
        this.urlParams = null;
        this.eventService.emitMoteEvent({ type: MoteEventType.INTROFLOW_CLOSED });
    }

    public watchUrlChange(): Observable<string> {
        return this.urlChangeSubject.asObservable();
    }

    public getUrlParams(): MotesUrlParams {
        return this.urlParams;
    }

    public getMoteEvent(): MoteEvent {
        return this.moteEvent;
    }

    public setLocalStorage(path: string): void {
        // Set path=true in local storage
        this.storage.store(path, true);
    }

    public async isLocalStorageSet(path: string): Promise<boolean> {
        // Check if path exist in local storage
        return this.storage.retrieve(path) ? true : false;
    }

    public clearLocalStorage(): void {
        this.storage.clear();
    }
}
